<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ATTESTATION_COMPTE')">
        <slot name="section-attestation-compte">
          <section-attestation-compte ref="ATTESTATION_COMPTE"
                                      id="ATTESTATION_COMPTE"
                                      :extended="isExtended('ATTESTATION_COMPTE')"
                                      :showButton="true"
                                      :autoSave="true"
                                      :readOnly="readOnly"
                                      :moduleId="moduleId"
                                      :searchText="searchText"
                                      :ressourceHeader="ressource"
                                      :fiche="fiche"
                                      :attestation=selectedAttestation
                                      :route="route"
                                      :attribut="attribut"
                                      @extended="setExtended"
                                      @fullscreen="setFullscreen"
                                      @status="updateStatus"
                                      @updated="attestationUpdated"
                                      @selectItem = "selectItem">
          </section-attestation-compte>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Attestation from '@/extend/classes/Attestation';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionAttestationCompte from '@/custom/sections/SectionAttestationCompte.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionAttestationCompte,
    FicheHeader,
  },

  props: {
    attestation: {
      type: Object as PropType<Attestation>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.ATTESTATION_COMPTE,
      sections: [
        'ATTESTATION_COMPTE',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_ATTESTATION_COMPTE);
    },

    selectedAttestation (): Attestation {
      return this.attestation
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    attestationUpdated (attestation: Attestation) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.attestation || this.attestation.id < 0) && value == 'ATTESTATION_COMPTE') {
        this.setExtended(new Extended('ATTESTATION_COMPTE', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
